import React from 'react';
import img from "../../../src/icons/logo.png"
export const  ThemedTitle = () => {
  return (
    <div>
        <img src={img} alt="" style={{width: "14rem"}}/>
    </div>
  );
}

